import { render, staticRenderFns } from "./PokemonPickerCard.vue?vue&type=template&id=6bb97156&scoped=true"
import script from "./PokemonPickerCard.vue?vue&type=script&lang=js"
export * from "./PokemonPickerCard.vue?vue&type=script&lang=js"
import style0 from "./PokemonPickerCard.vue?vue&type=style&index=0&id=6bb97156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb97156",
  null
  
)

export default component.exports